export * from './sale-category-coupon-assignment-from.component';
